
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { isDate } from "@/validation/Common/Dates/DateValidation";
import {
  getIsoDateString,
  getFormattedDateString,
  getCurrentDate,
} from "@/helpers/Dates/DateHelpers";

@Component
export default class DatePickerInMenu extends Vue {
  @Prop({ required: false, default: "" })
  label!: string;

  @PropSync("date", { default: "" })
  dateSync!: string;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  @Prop({ required: false, default: Array })
  errors!: string[];

  menuOpen = false;
  internalValidationErrors: string[] = [];
  parentValidationErrors: string[] = [];

  get errorMessages(): string[] {
    return this.internalValidationErrors.concat(this.errors);
  }

  public isValid(): boolean {
    return this.errorMessages.length === 0;
  }

  get datePickerDate() {
    return getIsoDateString(this.dateSync);
  }
  set datePickerDate(date: string) {
    this.internalValidationErrors = [];
    this.textInputDate = date;
  }

  get textInputDate() {
    return getFormattedDateString(this.dateSync);
  }
  set textInputDate(date: string) {
    this.internalValidationErrors = [];
    if (isDate(date)) {
      this.dateSync = getIsoDateString(date);
      this.$emit("changed");
    } else if (!this.disabled) {
      this.internalValidationErrors.push("Please select a valid date");
    }
  }

  private selectToday(): void {
    this.dateSync = getIsoDateString(getCurrentDate());
    this.$emit("changed");
  }

  @Watch("disabled")
  private disabledChanged(): void {
    if (this.disabled) {
      this.internalValidationErrors = [];
    }
  }
}
